export default {
  BASIC: 'basic',
  ADVANCED: 'advanced'
};
